// Events plugin — API helpers. Uses the app's shared axios instance.
import api from '../../lib/api';

export const listEvents = (status) =>
  api.get('/events', { params: status ? { status } : {} });
export const getEvent = (id) => api.get(`/events/${id}`);
export const createEvent = (data) => api.post('/events', data);
export const updateEvent = (id, data) => api.put(`/events/${id}`, data);
export const updateEventStatus = (id, status) => api.post(`/events/${id}/status`, { status });
export const deleteEvent = (id) => api.post(`/events/${id}/delete`);
export const listEventDispatches = (id) => api.get(`/events/${id}/dispatches`);
export const getEventReconciliation = (id) => api.get(`/events/${id}/reconciliation`);
export const saveEventReconciliation = (id, data) => api.post(`/events/${id}/reconciliation`, data);
export const attachDispatchToEvent = (id, dispatchId) =>
  api.post(`/events/${id}/attach-dispatch`, { dispatch_id: dispatchId });
export const detachDispatchFromEvent = (id, dispatchId) =>
  api.post(`/events/${id}/detach-dispatch`, { dispatch_id: dispatchId });
export const pushEventToAccountsIQ = (id, basis) =>
  api.post(`/events/${id}/push-to-accountsiq`, null, { params: basis ? { basis } : {} });
export const getEventInvoicePreview = (id, basis) =>
  api.get(`/events/${id}/invoice-preview`, { params: basis ? { basis } : {} });
export const addFreelinesToDispatch = (eventId, dispatchId, lines) =>
  api.post(`/events/${eventId}/dispatches/${dispatchId}/add-freelines`, { lines });
